/* eslint-disable no-unused-vars */
export enum UIInputVariants {
  common = 'common',
  green = 'green',
  pink = 'pink',
};
